import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M23.2402 41.87C23.2402 41.87 50.8702 27.42 52.2702 25.66C53.6702 23.9 54.6102 1 54.6102 1H76.6202C76.6202 1 77.5602 23.9 78.9603 25.66C80.3603 27.42 107.99 41.87 107.99 41.87C107.99 41.87 95.7402 56.92 65.6102 56.92C35.4802 56.92 23.2402 41.87 23.2402 41.87Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M9.52 47.5601C12.6 43.9301 46.2 27.64 46.2 27.64C46.2 27.64 48.79 33.64 58.64 37.16C64.03 39.09 65.91 41.51 65.91 41.51C65.91 41.51 66.65 40.53 68.55 39.14C69.85 38.19 71.51 37.48 73.76 36.67C81.64 33.87 85.39 27.91 85.39 27.91C85.39 27.91 118.63 43.9301 121.71 47.5601C124.79 51.1901 129.23 73.54 129.23 73.54H2C2 73.54 6.44 51.2001 9.52 47.5601Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M65.5796 67.24C66.2589 67.24 66.8096 66.6893 66.8096 66.01C66.8096 65.3307 66.2589 64.78 65.5796 64.78C64.9003 64.78 64.3496 65.3307 64.3496 66.01C64.3496 66.6893 64.9003 67.24 65.5796 67.24Z"
        fill={outline}
      />
      <path
        d="M65.5796 58.3501C66.2589 58.3501 66.8096 57.7993 66.8096 57.12C66.8096 56.4407 66.2589 55.89 65.5796 55.89C64.9003 55.89 64.3496 56.4407 64.3496 57.12C64.3496 57.7993 64.9003 58.3501 65.5796 58.3501Z"
        fill={outline}
      />
      <path
        d="M65.5796 49.4601C66.2589 49.4601 66.8096 48.9093 66.8096 48.23C66.8096 47.5507 66.2589 47 65.5796 47C64.9003 47 64.3496 47.5507 64.3496 48.23C64.3496 48.9093 64.9003 49.4601 65.5796 49.4601Z"
        fill={outline}
      />
      <path
        d="M90.3698 30.86C90.3698 30.86 87.3098 36.3901 80.6298 39.6901C73.9498 42.9901 68.9098 43.41 68.9098 54.14C68.9098 64.87 68.9098 70.8201 68.9098 70.8201H62.2998C62.2998 70.8201 62.2998 64.87 62.2998 54.14C62.2998 43.41 57.2598 42.9901 50.5798 39.6901C43.8898 36.3901 40.8398 30.86 40.8398 30.86"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M68.9902 52.3301C68.9902 52.3301 69.0702 41.68 59.9902 38.38"
        stroke={outline}
        fill="none"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="65.6151"
          y1="33.1883"
          x2="65.6151"
          y2="22.8848"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
